import {Col, Row} from "react-bootstrap";
import React from "react";

import {Card, NativeSelect} from "@mui/material";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";
import 'ckeditor5/ckeditor5.css';
import {handleDefaultValues} from "../common/Utils";
import {useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";

export default function EmailTemplates({company, handleSave, templates, savingCompany}) {
  const navigate = useNavigate();

  const {register, handleSubmit, setValue} = useForm({
    values: handleDefaultValues(company)
  });
  return (
  <Grid item xs={12}>
    <div id="communication-templates" style={{
      position: 'relative',
      left: '-999em',
      zIndex: '-999',
      top: '-100px'
    }}/>
    <Card>
      <MDBox p={3}>
        <h5>
          Message Automation
          <MDButton
            color="secondary"
            size="small"
            className={'pull-right'}
            onClick={(e) => {
              navigate('/communication/templates/new')
            }}>
            <Icon>email</Icon>&nbsp;Add Email Template
          </MDButton>
        </h5>
        <p className={'py-2 fw-light'}>
          Use email templates to define the content of emails and messages sent to customers
          in automated messages and actions.
        </p>
        {company && <form onSubmit={handleSubmit(handleSave)} id={'companyTemplatesForm'}>
          <Row className={'mt-2'}>
            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                New Account Created (Online)
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'newAccount'} name={'newAccount'} className={'form-control'}
                  {...register('newAccountTemplate.id', {
                    valueAsNumber: true,
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>
            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                New Account  (In Person)
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'automatedNewAccountTemplate'} name={'automatedNewAccountTemplate'}
                  className={'form-control'}
                  {...register('automatedNewAccountTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Password Reset
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'passwdResetTemplate'} name={'passwdResetTemplate'}
                  className={'form-control'}
                  {...register('passwdResetTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>
            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Party Registration Confirmation
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'partyRegistrationTemplate'} name={'partyRegistrationTemplate'}
                  className={'form-control'}
                  {...register('partyRegistrationTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Event Registration Confirmation
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'eventRegistrationTemplate'} name={'eventRegistrationTemplate'}
                  className={'form-control'}
                  {...register('eventRegistrationTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Purchase Receipt
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'purchaseReceiptTemplate'} name={'purchaseReceiptTemplate'}
                  className={'form-control'}
                  {...register('purchaseReceiptTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>
            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                New Invoice Notification
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'invoiceCreationTemplate'} name={'invoiceCreationTemplate'}
                  className={'form-control'}
                  {...register('invoiceCreationTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Invoice Reminder Notification
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'invoiceReminderTemplate'} name={'invoiceReminderTemplate'}
                  className={'form-control'}
                  {...register('invoiceReminderTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>


            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Event Cancellation
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'eventCancellationTemplate'} name={'eventCancellationTemplate'}
                  className={'form-control'}
                  {...register('eventCancellationTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Wait List Notification
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'eventWaitlistTemplate'} name={'eventWaitlistTemplate'}
                  className={'form-control'}
                  {...register('eventWaitlistTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Gift Card
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'giftCardRedemptionTemplate'} name={'giftCardRedemptionTemplate'}
                  className={'form-control'}
                  {...register('giftCardRedemptionTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Gifted Membership
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'giftRedemptionTemplate'} name={'giftRedemptionTemplate'}
                  className={'form-control'}
                  {...register('giftRedemptionTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>

            <Col className={'col p-2'} sm={6} xs={12}>
              <MDTypography variant="p" fontWeight="medium">
                Refund
              </MDTypography>
              <div className="form-group">
                {templates?.length && <NativeSelect
                  variant="outlined"
                  id={'refundTemplate'} name={'refundTemplate'}
                  className={'form-control'}
                  {...register('refundTemplate.id', {
                    valueAsNumber: true
                  })}>
                  {
                    templates.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.templateName}
                      </option>)
                  }
                </NativeSelect>}

              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <MDButton className={'mt-2 pull-right'}
                        type="submit"
                        variant="gradient"
                        size={'small'}
                        disabled={savingCompany}
                        color="info">
                {savingCompany ? 'Saving' : 'Save'}
              </MDButton>
            </Col>
          </Row>
        </form>}
      </MDBox>
    </Card>
  </Grid>
  );
}